module.exports = {
    siteUrl: `https://codechacha.com`,
    siteTitleMeta: `codechacha`,
    siteDescriptionMeta: `Java, Kotlin, Android, Python, Linux 등 Programming, Software 개발 방법을 다룹니다.`,
    shortTitle: `codechacha.com`,
    siteIcon: `https://codechacha.com/assets/icon/android-icon-192x192.png`,
    siteLogo: `https://codechacha.com/assets/icon/android-icon-192x192.png`,
    keywords: `Software, Computer Science, Web, Mobile, Java, Android, Python, Linux, Kotlin`,
    email: `farfs.dev@gmail.com`,
    disqus: `codechacha`,
    github: `https://github.com/codechacha`,
    twitter: `https://twitter.com/codechacha`,
    authorTwitterAccount: `@codechacha`,
    authorName: `JS`,
    authorIconSmall: `/assets/images/user-js-48.png`,
    authorIconBig: `/assets/images/user-js-96.png`
}
